<template>
<div class="chapter">
<div class="inner_page">
<blockquote class="epigraph" epub:type="epigraph" role="doc-epigraph">
<p class="epi"><span aria-label="page viii" epub:type="pagebreak" id="page_viii" role="doc-pagebreak"><span aria-label="page ix" epub:type="pagebreak" id="page_ix" role="doc-pagebreak"><i>And I will show that nothing can happen more beautiful than death.</i></span></span></p>
<p class="epir">—Walt Whitman</p>
<p class="epir1"><i> Leaves of Grass</i>, “Proto-Leaf” (1860)</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0816890a